import { GetPulseResponse } from './getPulseResponse';

export const GetPulseServiceMock: GetPulseResponse = {
  data: 'Mocking pulse service call...',
  succeeded: true,
};
